import reducer from './reducer';

export const { openBasketModal, closeBasketModal, openOverviewModal, closeOverviewModal } = reducer.actions;
